import { Dispatch, SetStateAction, useMemo } from 'react';
import { FilterSelect } from '../FilterSelect';
import { ace_index } from '@axo/shared/data-access/types';
import { setPageNumber } from '../SearchResults';
import { useAvailableClients } from '../../hooks/utils/useAvailableClients';

interface Props {
  query: ace_index.FindInput;
  setQuery: Dispatch<SetStateAction<ace_index.FindInput>>;
  editable?: boolean;
}

export function Portfolio({ query, setQuery, editable = false }: Props) {
  const clients = useAvailableClients();
  const options = useMemo(
    () => [
      {
        label: 'All',
        value: undefined,
      },
      {
        label: 'Mine',
        value: 'self',
      },
      {
        label: 'Unassigned',
        value: '',
      },
      ...clients.map((client) => ({
        label: client.DisplayName,
        value: client.ID,
      })),
    ],
    [clients]
  );

  const state = getPortfolio(query);
  const value = options.find((option) => option.value === state) ?? options[0];

  return (
    <FilterSelect
      items={options}
      onSelect={(option) => setQuery(setPortfolio(option.value))}
      stringify={(option) => option.label}
      value={value}
      label="Portfolio"
      description="Filter mine/all applications"
      disabled={!editable}
      filterable
    />
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function setPortfolio(clientID: Value): (query: ace_index.FindInput) => ace_index.FindInput {
  return (query) => ({
    ...setPageNumber(1)(query),
    AssignmentClientID: clientID,
  });
}

function getPortfolio(query: ace_index.FindInput) {
  return query.AssignmentClientID;
}

type Value = ace_index.FindInput['AssignmentClientID'];
